import React from "react";

function NavDao(props) {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container">
      <a href="/" className="navbar-brand mb-0 h1">
      <img className="d-inline-block align-top" width={"100px"} height={"100px"} src={"assets/TSD-LOGO.png"}/>
          <span className="title-font" style={{color: 'rgb(255,184,191)'}}>Trippy </span><span className="title-font" style={{color: 'rgb(83,176,174)'}}>Steve's </span><span className="title-font" style={{color: 'rgb(224,165,38)'}}>DAO</span>
      </a>
      <button 
      style={{margin: 0, margin: "auto"}}
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarNav"
      className="navbar-toggler"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      >
          <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse"
      id="navbarNav">
      <ul className="navbar-nav">
          <li><a href="/">Home</a></li>
          <li><a href="/giveaways">Giveaways</a></li>
          <li><a href="https://discord.gg/h3wyZXWTfh">Discord</a></li>
          <li className="link-active"><a href="/mint">Mint</a></li>
      </ul>
      </div>
      </div>
   </nav>
   );
}

export default NavDao;
